import React, { useCallback, useLayoutEffect, useMemo, useState } from "react";
import { Button, Col, Container, Dropdown, Form, Row } from "react-bootstrap";
import { CommonSelect, CommonToolTip, CstmPagination } from "../../../components/Common/Common";
import { generatePath, Link, useNavigate } from "react-router-dom";
import {
    useDeleteTherapistMutation,
    useGetTherapistsListQuery,
    useResendAccountActivationMutation
} from "store/services/therapistProfiles";
import { SCHOOL_BANNERS_ADD, SCHOOL_BANNERS_EDIT, THERAPIST_DETAIL, THERAPIST_EDIT } from "config/paths";
import LoadingOverlay from "components/shared/LoadingOverlay";
import LoadingIndicator from "components/shared/LoadingIndicator";
import { ArchiveIcon, ChatIcon, DeleteIcon, EditIcon, UnArchiveIcon } from "Assets/icons";
import { dateFormat, successMessageToast } from "helpers/common";
import ErrorComponent from "components/shared/ErrorComponent";
import ConfirmationPop from "components/Modals/ConfirmationPop";
import dummyUserImage from "Assets/images/dummy_user.jpg";
import AlertPop from "components/Modals/AlertPop";
import { useArchiveTherapistMutation } from "store/services/archive";
import { useDispatch, useSelector } from "react-redux";
import { schoolBanner, schoolBannerFilter, schoolBannerFilterFilter } from "store/slices/filter";
import { THERAPIST_STATUS_OPTIONS, THERAPIST_TYPE_OPTIONS } from "config/constants";
import { Star } from "react-feather";
import { debounce } from "lodash";
import { RightArrowIcon, ThreeDotsMenuIcon } from "Assets/icons/V2";
import TableLayoutV2 from "components/TableLayoutV2";
import { useDeleteSchoolBannerMutation, useFavoriteSchoolBannerMutation, useGetSchoolBannersListQuery } from "store/services/schoolBanners";
import confirmDialogV2 from "utils/confirmationDialogV2";

const ManageSchoolBanners = () => {

    const navigate = useNavigate();

    const dispatch = useDispatch();
    const filter = useSelector(state => state?.filter?.schoolBannerFilter);

    const [showAlertModal, setShowAlertModal] = useState(false);
    const [currentEntry, setCurrentEntry] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);

    const [therapistProfiles, setTherapistProfiles] = useState([]);

    const { data, isLoading, isError, isFetching, refetch } = useGetSchoolBannersListQuery({
        page: currentPage,
        limit: pageSize,
        ...filter,
    });
    const [deleteSchoolBanner, { isLoading: deleteSchoolBannerLoading }] = useDeleteSchoolBannerMutation();
    const [favoriteBanner, { isLoading: favoriteBannerLoading }] = useFavoriteSchoolBannerMutation()

    const totalRecords = data?.totalRecords || 0;
    const totalPages = Math.ceil(totalRecords / pageSize);

    const handleEditItem = (id) => {
        navigate(generatePath(SCHOOL_BANNERS_EDIT, { id }));
    };

    const handleFavoriteBanner = async (id, favorite) => {
        const data = {
            favorite
        }
        try {
            await favoriteBanner({ data, id }).unwrap()
        } catch (error) {
            console.log('error making the banner favorite: ', error)
        }
    }

    const column = useMemo(() => [
        {
            head: <div onClick={() => {
                handleFilterChange("sort")(filter?.sort?.column == "is_favorite" ? { column: "id", direction: "desc" } : { column: "is_favorite", direction: "desc" })
                // dispatch(schoolClientsFilter({ ...filter, sort: filter?.sort?.column == "is_favorite" ? { column: "lastname", direction: "asc" } : { column: "is_favorite", direction: "desc" } }))
            }
            }>{filter?.sort?.column == "is_favorite" ? <Star fill="#315D99" stroke="#315D99" width={18} /> : <Star width={18} stroke="#8F8F8F" />}</div>,
            accessor: "is_favorite",
            isComponent: true,
            component: (item, ind) => (
                <h6 style={{ cursor: "pointer" }} className="m-0 text-capitalize cursor-pointer d-flex align-items-center gap-2"><div className="cursor-pointer" onClick={(e) => { e.stopPropagation(); handleFavoriteBanner(item?.id, item?.is_favorite ? 0 : 1) }}>{item?.is_favorite ? <Star fill="#315D99" stroke="#315D99" width={18} /> : <Star width={18} stroke="#8F8F8F" />}</div></h6>
            ),
        },
        {
            head: <span style={{ width: 90 }}>Date</span>,
            accessor: "createdAt",
            sorter: true,
            isComponent: true,
            component: (item, ind) => (
                <p className="m-0">{dateFormat(item?.createdAt, 'MMM DD, YYYY')}</p>
            ),
        },
        {
            head: "BANNER",
            accessor: "title",
            sorter: true,
            component: (item) => (
                <p className="m-0">{item?.title}</p>
            )
        },
        {
            head: "Account Status",
            accessor: "status",
            sorter: true,
            isComponent: true,
            component: (item, ind) => (
                <div>
                    <p
                        style={{ width: 80, fontStyle: item?.status != "published" && "italic", textAlign: "left" }}
                        className={`${item.status == "active"
                            && "greenStatus"
                            // : "redStatus"
                            } status text-capitalize m-0  rounded-pill px-2 py-1`}
                    >
                        {item.status}
                    </p>
                </div>
            ),
        },
        {
            head: "",
            accessor: "",
            isComponent: true,
            component: (item) => (
                <div className="ActnBtn d-flex justify-content-between align-items-center  gap-10">
                    <Dropdown
                        onClick={(e) => e.stopPropagation()}
                    // show={index == dropdownIndex}
                    // onToggle={() => setDropdownIndex(index == dropdownIndex ? null : index)}
                    >
                        <Dropdown.Toggle
                            variant="transparent"
                            className="p-0 border-0 text-dark w-100"
                            id="dropdown-basic"
                        >
                            <ThreeDotsMenuIcon />
                        </Dropdown.Toggle>
                        <Dropdown.Menu className="" style={{ right: 0, left: "unset" }}>
                            <ul className="list-unstyled mb-0" style={{ paddingLeft: "19px" }}>
                                <h5 onClick={(e) => {
                                    e.stopPropagation();
                                    handleEditItem(item.id);
                                }} className="cursor-pointer proxima mb-2">
                                    Edit
                                </h5>
                                <h5 onClick={(e) => {
                                    e.stopPropagation();
                                    handleDeleteBanner(e, item.id);
                                }}
                                    className="cursor-pointer proxima mb-2">
                                    Delete
                                </h5>
                            </ul>
                        </Dropdown.Menu>
                    </Dropdown>
                    {/* <Dropdown
                    >
                        <Dropdown.Toggle
                            variant="transparent"
                            className="p-0 border-0 text-dark w-100"
                            id="dropdown-basic"
                        >
                            <RightArrowIcon />
                        </Dropdown.Toggle>

                    </Dropdown>

                    {
                        item?.status == "complete" && <div
                            className="cursor-pointer d-flex align-items-center"
                            style={{ padding: "10px 10px" }}
                            onClick={(e) => {
                                e.stopPropagation(); // prevent row navigation
                                toggleRow(item.id);
                            }}
                        >
                            {openRow === item.id ? (
                                <img width={12} src={downArrow} alt="Collapse" />
                            ) : (
                                <img width={7} src={rightArrow} alt="Expand" />
                            )}
                        </div>
                    } */}
                </div >

            ),
        },
    ]);

    const resetFilter = () => {
        dispatch(schoolBannerFilter({ search: "", type: "", status: "active", sort: { column: "id", direction: "desc", } }));
        setCurrentPage(1)
    };

    const handleFilterChange = (key) => (value) => {
        dispatch(schoolBannerFilter({ ...filter, [key]: value }))
        setCurrentPage(1); // Reset to first page when filter changes
    };

    const handleSearchChange = useCallback(debounce((value) => {
        setCurrentPage(1);
        handleFilterChange("search")(value);
    }, 500), [handleFilterChange, 500]);

    const handlePageChange = (page) => {
        window.scrollTo(0, 0);
        setCurrentPage(page);
    };

    const handleDeleteBanner = async (e, id) => {
        try {
            e.stopPropagation();
            const isConfirm = await confirmDialogV2({
                title: `REMOVE SCHOOL BANNER?`,
                message: `Are you sure you want to remove this school banner?`,
            });
            if (!isConfirm) {
                return
            }
            const response = await deleteSchoolBanner({ id }).unwrap();
            successMessageToast(response?.message);
        } catch (err) {
            console.log("error deleting school banner", err);
        }
    };

    useLayoutEffect(() => {

        if (data?.records) setTherapistProfiles(data?.records)
    }, [data]);

    return (
        <>

            <AlertPop
                confirmation={showAlertModal}
                setConfirmation={setShowAlertModal}
                message={"The account has been already verified"}
            />

            <section className="ManageProfile position-relative py-4">
                <Container fluid={true}>
                    <Row>
                        <Col lg="12" className="my-2">

                            <div className="TableFilter d-flex align-items-center justify-content-between gap-10 flex-wrap">
                                <div className="clinican-head">
                                    <div className="left classroom-conslutation">
                                        <h6 className="m-0 fw-bold main-head themeBlue">School Banners</h6>
                                    </div>
                                    {/* <div className="d-flex gap-3">
                                        <div className="w-100 d-flex align-items-center gap-2 reports-v2 classroom-conslutation">
                                            <label className="discharge-screen-label mb-0">Show</label>
                                            <CommonSelect
                                                placeholder={"Select"}
                                                option={THERAPIST_STATUS_OPTIONS}
                                                onChange={(e) => handleFilterChange("status")(e)}
                                                value={filter?.status}
                                                isFilterV2
                                                styles={{
                                                    container: (provided) => ({
                                                        ...provided,
                                                        width: "100%",
                                                    }),
                                                }}
                                            />
                                        </div>
                                        <div className="w-100 d-flex align-items-center gap-2 reports-v2 classroom-conslutation">
                                            <label className="discharge-screen-label mb-0">Search</label>
                                            <input
                                                onChange={(e) => handleSearchChange(e.target.value)}
                                                // style={{outline: "blue"}}
                                                className={`input-new readonly-box h-auto search-input-filter-v2`}
                                                placeholder="Find a therapist..."
                                                defaultValue={filter?.search}
                                            />
                                        </div>
                                    </div> */}
                                </div>
                                <div className="right">
                                    <ul className="list-unstyled ps-0 mb-0 d-flex align-items-center justify-content-center flex-wrap gap-10">
                                        <li className="">
                                            <Link to={SCHOOL_BANNERS_ADD} className="blue-discharge-screen-btn-new mt-0 d-flex align-items-center justify-content-center">
                                                Add Banner
                                            </Link>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </Col>
                    </Row>
                    {/* <Row className="reports-v2 my-3 d-flex justify-content-end classroom-conslutation">
            <Col md='2'>
              <div className="w-100 align-items-center gap-3">
                <label className="discharge-screen-label mb-0">Type</label>
                <CommonSelect
                  placeholder={"Select Type"}
                  option={THERAPIST_TYPE_OPTIONS?.map((item) => ({ label: item?.label, value: item?.value }))}
                  onChange={handleFilterChange("type")}
                  value={filter?.type}
                  isFilterV2
                  isClearable
                  // isLoading={schoolListLoading || schoolListFetching}
                  styles={{
                    container: (provided) => ({
                      ...provided,
                      width: "100%", // ✅ Ensures the whole Select container is full width
                    }),
                  }}
                />
              </div>
            </Col>
            <Col md='2'>
              <div className="w-100 align-items-center gap-3">
                <label className="discharge-screen-label mb-0">Status</label>
                <CommonSelect
                  placeholder={"Select"}
                  option={THERAPIST_STATUS_OPTIONS}
                  onChange={(e) => handleFilterChange("status")(e)}
                  value={filter?.status}
                  isFilterV2
                  // isClearable
                  // isLoading={schoolListLoading || schoolListFetching}
                  styles={{
                    container: (provided) => ({
                      ...provided,
                      width: "100%", // ✅ Ensures the whole Select container is full width
                    }),
                  }}
                />
              </div>
            </Col>
            <Col lg="2" style={{ borderLeft: "1px solid #315D99" }}>
              <div className="w-100 align-items-center gap-3">
                <label className="discharge-screen-label mb-0">Search</label>
                <input
                  onChange={(e) => handleSearchChange(e.target.value)}
                  // style={{outline: "blue"}}
                  className={`input-new readonly-box h-auto search-input-filter-v2`}
                  placeholder="Find a therapist..."
                  defaultValue={filter?.search}
                />
              </div>
            </Col>
          </Row> */}
                    <Row>
                        <Col lg="12" className="my-2">
                            {/* <TableHeader
                heading={"Therapist Profile"}
                handleFilterChange={handleFilterChange}
                resetFilter={resetFilter}
                filter={filter}
                searchPlaceholder="Last, First Name, Email"
                filterComponent={
                  <>
                    <li className="">
                      <Dropdown
                        onSelect={handleFilterChange("type")}
                      >
                        <Dropdown.Toggle
                          variant="transparent"
                          className="border-0 d-flex align-items-center  justify-content-center"
                          id="dropdown-basic"
                        >
                          {THERAPIST_TYPE_OPTIONS.find(x => x.value == filter.type)?.label || "Select Type"}
                          <span className="icn ms-2">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="12"
                              height="8"
                              viewBox="0 0 12 8"
                              fill="none"
                            >
                              <path
                                d="M1.415 0.298828L6 4.731L10.585 0.298828L12 1.66666L6 7.46666L0 1.66666L1.415 0.298828Z"
                                fill="black"
                              />
                            </svg>
                          </span>
                        </Dropdown.Toggle>

                        <Dropdown.Menu
                          style={{
                            maxHeight: "200px",
                            overflowY: "scroll"
                          }}
                        >
                          {
                            THERAPIST_TYPE_OPTIONS.map((item, index) => {
                              return <Dropdown.Item key={index} eventKey={item.value}>{item?.label}</Dropdown.Item>
                            })
                          }
                        </Dropdown.Menu>
                      </Dropdown>
                    </li>
                  </>
                }
              >
                <ul className="list-unstyled ps-0 mb-0 d-flex align-items-center justify-content-center flex-wrap gap-10">
                  <li className="">
                    <Link
                      to="/manage-team/therapist-profiles/add"
                      className="btn text-white d-flex align-items-center justify-content-center commonBtn fw-sbold "
                    >
                      <span className="icn me-1">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="19"
                          height="19"
                          viewBox="0 0 19 19"
                          fill="none"
                        >
                          <mask
                            id="mask0_0_4440"
                            style={{ maskType: "alpha" }}
                            maskUnits="userSpaceOnUse"
                            x="0"
                            y="0"
                            width="19"
                            height="19"
                          >
                            <rect
                              width="18.7197"
                              height="18.7197"
                              fill="#D9D9D9"
                            />
                          </mask>
                          <g mask="url(#mask0_0_4440)">
                            <path
                              d="M8.57996 13.2594H10.1399V10.1394H13.2599V8.57947H10.1399V5.45951H8.57996V8.57947H5.46V10.1394H8.57996V13.2594ZM9.35995 17.1593C8.28096 17.1593 7.26698 16.9546 6.31799 16.5451C5.369 16.1356 4.54352 15.5799 3.84153 14.8779C3.13954 14.1759 2.58379 13.3504 2.1743 12.4014C1.76481 11.4524 1.56006 10.4384 1.56006 9.35946C1.56006 8.28047 1.76481 7.26649 2.1743 6.3175C2.58379 5.36851 3.13954 4.54303 3.84153 3.84104C4.54352 3.13905 5.369 2.58331 6.31799 2.17381C7.26698 1.76432 8.28096 1.55957 9.35995 1.55957C10.4389 1.55957 11.4529 1.76432 12.4019 2.17381C13.3509 2.58331 14.1764 3.13905 14.8784 3.84104C15.5804 4.54303 16.1361 5.36851 16.5456 6.3175C16.9551 7.26649 17.1598 8.28047 17.1598 9.35946C17.1598 10.4384 16.9551 11.4524 16.5456 12.4014C16.1361 13.3504 15.5804 14.1759 14.8784 14.8779C14.1764 15.5799 13.3509 16.1356 12.4019 16.5451C11.4529 16.9546 10.4389 17.1593 9.35995 17.1593ZM9.35995 15.5994C11.1019 15.5994 12.5774 14.9949 13.7864 13.7859C14.9954 12.5769 15.5999 11.1014 15.5999 9.35946C15.5999 7.61748 14.9954 6.142 13.7864 4.93302C12.5774 3.72404 11.1019 3.11955 9.35995 3.11955C7.61797 3.11955 6.14249 3.72404 4.93351 4.93302C3.72453 6.142 3.12004 7.61748 3.12004 9.35946C3.12004 11.1014 3.72453 12.5769 4.93351 13.7859C6.14249 14.9949 7.61797 15.5994 9.35995 15.5994Z"
                              fill="white"
                            />
                          </g>
                        </svg>
                      </span>{" "}
                      Add New Therapist
                    </Link>
                  </li>
                </ul>
              </TableHeader> */}
                            <div className="table-outer">
                                {isLoading ? (
                                    <div style={{ height: "200px" }}>
                                        <LoadingIndicator />
                                    </div>
                                ) : isError ? (
                                    <ErrorComponent />
                                ) : (
                                    <>
                                        {(isFetching || deleteSchoolBannerLoading || favoriteBannerLoading) && <LoadingOverlay />}
                                        {/* <TableLayout
                      data={therapistProfiles}
                      column={column}
                      url={"/manage-team/therapist-profiles/detail"}
                      filter={filter}
                      handleSort={handleFilterChange("sort")}
                    /> */}
                                        <TableLayoutV2
                                            data={data?.records}
                                            column={column}
                                            url={SCHOOL_BANNERS_EDIT.replace("/:id", "")}
                                            filter={filter}
                                            handleSort={handleFilterChange("sort")}
                                        />
                                        <CstmPagination
                                            totalPages={totalPages}
                                            activePage={currentPage}
                                            className="paginationV2"
                                            handlePageChange={handlePageChange}
                                        />
                                    </>
                                )}
                                {/* <CstmPagination
                  totalPages={totalPages}
                  activePage={currentPage}
                  handlePageChange={handlePageChange}
                /> */}
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>
        </>
    );
};

export default ManageSchoolBanners;
